/*
  Lisa Kookt: reviewtitels "Over de <product>" tonen als "Over <product>" (20-10-2026, JJ).

  Waarom in het thema: de titels staan zo opgeslagen in Judge.me bij de
  gekopieerde reviews op de pakketten (ruim 500 stuks). Judge.me kan titels van
  bestaande reviews niet in bulk aanpassen, dus corrigeren we ze bij het tonen.

  Alleen als na "Over de " een hoofdletter volgt (een productnaam). Zo blijft
  een klanttitel als "Over de bezorging" ongemoeid.
  Werkt ook op reviews die later binnenkomen (volgende pagina, sorteren,
  carrousels), via een MutationObserver.
  Terugdraaien: de script-regel onderaan snippets/meta-tags.liquid weghalen.
*/
(function () {
  var RE = /^(\s*)Over de (?=[A-Z\u00C0-\u00DE0-9])/;
  var SEL = '.jdgm-rev__title, [class*="jdgm"][class*="review-title"], [class*="jdgm"][class*="rev__title"]';
  function fix(root) {
    var els = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      var n = els[i].firstChild;
      while (n && n.nodeType !== 3) n = n.firstChild;
      if (n && RE.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(RE, '$1Over ');
    }
  }
  var t;
  function later() { clearTimeout(t); t = setTimeout(function () { fix(); }, 30); }
  if (document.readyState !== 'loading') fix();
  else document.addEventListener('DOMContentLoaded', function () { fix(); });
  try { new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
})();
